import PropTypes from "prop-types";
import React, { useEffect, useRef, useState } from "react";
import $ from "jquery";
import logolight from "../../assets/images/logo-light.png";
import logodark from "../../assets/images/logo-dark.png";

import {
  Row,
  Col,
  CardBody,
  Card,
  Container,
  Form,
  Input,
  FormFeedback,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  Spinner,
} from "reactstrap";

//redux
import { useSelector, useDispatch } from "react-redux";

import { Link, useNavigate } from "react-router-dom";
import withRouter from "../../components/Common/withRouter";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

//Social Media Imports
import { GoogleLogin } from "react-google-login";
// import TwitterLogin from "react-twitter-auth"
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";

// actions
// import { loginUser, socialLogin, } from "../../store/actions";

//Import config
import { facebook, google } from "../../config";
import { loginUser, verifyOtp, clearOtpState } from "../../Features/Authentication/userSlice";
import { REMEMBER_ME_KEY, USER_DATA_KEY } from "../../components/Common/Const";

const Login = (props) => {
  const _rememberMe = JSON.parse(localStorage.getItem(REMEMBER_ME_KEY) || null);
  const [rememberMe, setRememberMe] = useState(_rememberMe || false)
  document.title = "Login ";
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { error, token, isUserLogout, otp, isLoading } = useSelector((state) => state.user);
  const [otpDigits, setOtpDigits] = useState(Array(6).fill(""));
  const otpInputRefs = useRef([]);
  const otpAutoSubmitted = useRef(false);
  const getInitialValues = () => {
    const userData = JSON.parse(localStorage.getItem(USER_DATA_KEY) || null);
    if (userData) return userData
    return {
      userName: "",
      password: "",
    }
  }
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: getInitialValues(),
    validationSchema: Yup.object({
      userName: Yup.string().required("Please Enter Your Username"),
      password: Yup.string().required("Please Enter Your Password"),
    }),
    onSubmit: (values) => {
      dispatch(loginUser(values));
    },
  });


  useEffect(() => {
    if (token && !isUserLogout) {
      navigate('/dashboard');
    } else {
      navigate('/login');
    }
  }, [token])

  const handleRememberMe = () => {
    if (rememberMe === true) {
      localStorage.setItem(REMEMBER_ME_KEY, false)
      setRememberMe(false)
    } else if (rememberMe === false) {
      localStorage.setItem(REMEMBER_ME_KEY, true)
      setRememberMe(true)
    }
  };
  const signIn = (res, type) => {
    if (type === "google" && res) {
      const postData = {
        name: res.profileObj.name,
        userName: res.profileObj.userName,
        token: res.tokenObj.access_token,
        idToken: res.tokenId,
      };
      // dispatch(socialLogin(postData, props.router.navigate, type));
    } else if (type === "facebook" && res) {
      const postData = {
        name: res.name,
        userName: res.userName,
        token: res.accessToken,
        idToken: res.tokenId,
      };
      // dispatch(socialLogin(postData, props.router.navigate, type));
    }
  };

  //handleGoogleLoginResponse
  const googleResponse = (response) => {
    signIn(response, "google");
  };

  //handleTwitterLoginResponse
  // const twitterResponse = e => {}

  //handleFacebookLoginResponse
  const facebookResponse = (response) => {
    signIn(response, "facebook");
  };

  useEffect(() => {
    // const AuthUse  r = localStorage.getItem("rememberMe");
    // if (AuthUser == "true") {
    //   setRememberMe(true)
    //   const userAuth = decryptData(localStorage.getItem("authUser"));
    //   const { userName, password } = userAuth?.result;
    //   validation.setValues({
    //     userName: userName, // Replace with your saved userName logic
    //     password: password, // Replace with your saved password logic
    //   });
    // }
    document.body.className = "login-animated-bg";

    // jQuery: spawn a few softly floating gradient orbs behind the login card
    const orbColors = ["#0AB39C", "#405189", "#f7b84b", "#f06548", "#299cdb"];
    const $container = $('<div class="login-orb-container"></div>').appendTo("body");
    const orbCount = 5;

    for (let i = 0; i < orbCount; i++) {
      const size = 180 + Math.random() * 180;
      $("<div class='login-orb'></div>")
        .css({
          width: size,
          height: size,
          top: `${Math.random() * 80}%`,
          left: `${Math.random() * 90}%`,
          background: orbColors[i % orbColors.length],
          animationDuration: `${10 + Math.random() * 8}s`,
          animationDelay: `${Math.random() * 5}s`,
        })
        .appendTo($container);
    }

    // Subtle parallax: the whole orb group drifts opposite the cursor
    const handleMouseMove = (e) => {
      const xPercent = (e.clientX / window.innerWidth - 0.5) * 2;
      const yPercent = (e.clientY / window.innerHeight - 0.5) * 2;
      $container.css("transform", `translate(${xPercent * -20}px, ${yPercent * -20}px)`);
    };
    $(document).on("mousemove.loginParallax", handleMouseMove);

    // remove classname when component will unmount
    return function cleanup() {
      document.body.className = "";
      $(document).off("mousemove.loginParallax");
      $container.remove();
    };
  }, []);

  const handleFormSubmit = (e) => {
    e.preventDefault();
    validation.handleSubmit();
    return false;
  }

  const submitOtp = (code) => {
    if (otp?.userId && code.length === 6 && !otpAutoSubmitted.current) {
      otpAutoSubmitted.current = true;
      dispatch(verifyOtp({ userId: otp.userId, code }));
    }
  };

  const handleVerifyOtp = (e) => {
    e.preventDefault();
    submitOtp(otpDigits.join(""));
    return false;
  };

  const handleOtpDigitChange = (index, rawValue) => {
    const value = rawValue.replace(/\D/g, "").slice(-1);
    setOtpDigits((prev) => {
      const next = [...prev];
      next[index] = value;
      return next;
    });
    if (value && index < 5) {
      otpInputRefs.current[index + 1]?.focus();
    }
  };

  const handleOtpKeyDown = (index, e) => {
    if (e.key === "Backspace" && !otpDigits[index] && index > 0) {
      otpInputRefs.current[index - 1]?.focus();
    }
  };

  const handleOtpKeyUp = (index, e) => {
    if (index !== 5) return;
    const lastValue = e.target.value.replace(/\D/g, "").slice(-1);
    const code = otpDigits.map((d, i) => (i === 5 ? lastValue : d)).join("");
    if (code.length === 6) {
      submitOtp(code);
    }
  };

  const handleOtpPaste = (e) => {
    const pasted = e.clipboardData.getData("text").replace(/\D/g, "").slice(0, 6);
    if (!pasted) return;
    e.preventDefault();
    setOtpDigits(Array.from({ length: 6 }, (_, i) => pasted[i] || ""));
    const lastIndex = Math.min(pasted.length, 6) - 1;
    otpInputRefs.current[lastIndex >= 0 ? lastIndex : 0]?.focus();
  };

  const handleCloseOtpModal = () => {
    dispatch(clearOtpState());
  };

  // Reset the OTP boxes whenever a new OTP session starts and focus the first box
  useEffect(() => {
    if (otp?.userId) {
      setOtpDigits(Array(6).fill(""));
      otpAutoSubmitted.current = false;
      setTimeout(() => otpInputRefs.current[0]?.focus(), 0);
    }
  }, [otp?.userId]);

  // Auto-verify as soon as all 6 boxes are filled
  useEffect(() => {
    const code = otpDigits.join("");
    if (otp?.userId && code.length === 6 && !otpAutoSubmitted.current && !isLoading) {
      submitOtp(code);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [otpDigits]);

  // If verification fails, clear the boxes so the user can retry
  useEffect(() => {
    if (otp?.userId && error) {
      setOtpDigits(Array(6).fill(""));
      otpAutoSubmitted.current = false;
      otpInputRefs.current[0]?.focus();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error]);

  return (
    <React.Fragment>
      <div className="account-pages my-5 pt-5" style={{ position: "relative", zIndex: 1 }}>
        <Container>
          <Row className="justify-content-center">
            <Col lg={6} md={8} xl={4}>
              <Card>
                <CardBody className="p-4">
                  <div>
                    <div className="text-center">
                      {/* <Link to="/">
                        <img
                          src={logodark}
                          alt=""
                          height="24"
                          className="auth-logo logo-dark mx-auto"
                        />
                        <img
                          src={logolight}
                          alt=""
                          height="24"
                          className="auth-logo logo-light mx-auto"
                        />
                      </Link> */}
                    </div>
                    <h4 className="font-size-18 text-muted mt-2 text-center">
                      Welcome Back !
                    </h4>
                    <p className="mb-5 text-center">
                      Sign in to continue to Scorepanel.
                    </p>
                    <Form
                      className="form-horizontal"
                      onSubmit={handleFormSubmit}
                    >
                      {/* {error ? (
                        <Alert color="danger">
                          <div className="text-center">{error}</div>
                        </Alert>
                      ) : null} */}
                      <Row>
                        <Col md={12}>
                          <div className="mb-4">
                            <Label className="form-label">Username</Label>
                            <Input
                              name="userName"
                              className="form-control"
                              placeholder="Enter userName"
                              type="userName"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.userName || ""}
                              invalid={
                                validation.touched.userName &&
                                  validation.errors.userName
                                  ? true
                                  : false
                              }
                            />
                            {validation.touched.userName &&
                              validation.errors.userName ? (
                              <FormFeedback type="invalid">
                                <div>{validation.errors.userName}</div>
                              </FormFeedback>
                            ) : null}
                          </div>
                          <div className="mb-4">
                            <Label className="form-label">Password</Label>
                            <Input
                              name="password"
                              value={validation.values.password || ""}
                              type="password"
                              placeholder="Enter Password"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              invalid={
                                validation.touched.password &&
                                  validation.errors.password
                                  ? true
                                  : false
                              }
                            />
                            {validation.touched.password &&
                              validation.errors.password ? (
                              <FormFeedback type="invalid">
                                <div> {validation.errors.password} </div>
                              </FormFeedback>
                            ) : null}
                          </div>

                          <Row>
                            <Col>
                              <div className="form-check">
                                <input
                                  checked={rememberMe}
                                  onClick={handleRememberMe}
                                  type="checkbox"
                                  className="form-check-input"
                                  id="customControlInline"
                                  readOnly
                                />
                                <label
                                  className="form-label form-check-label"
                                  htmlFor="customControlInline"
                                >
                                  Remember me
                                </label>
                              </div>
                            </Col>
                            {/* <Col className="col-7"> */}
                            {/* <div className="text-md-end mt-3 mt-md-0">
                                <Link
                                  to="/auth-recoverpw"
                                  className="text-muted"
                                >
                                  <i className="mdi mdi-lock"></i> Forgot your
                                  password?
                                </Link>
                              </div> */}
                            {/* </Col> */}
                          </Row>
                          <div className="d-grid mt-4">
                            <button
                              className="btn btn-primary waves-effect waves-light"
                              type="submit"
                            >
                              Log In
                            </button>
                          </div>
                          {/* <div className="mt-4 text-center">
                            <h5 className="font-size-14 mb-3">Sign in with</h5>

                            <ul className="list-inline">
                              <li className="list-inline-item">
                                <FacebookLogin
                                  appId={facebook.APP_ID}
                                  autoLoad={false}
                                  callback={facebookResponse}
                                  render={(renderProps) => (
                                    <Link
                                      to="#"
                                      className="social-list-item bg-primary text-white border-primary"
                                      onClick={renderProps.onClick}
                                    >
                                      <i className="mdi mdi-facebook" />
                                    </Link>
                                  )}
                                />
                              </li>

                              <li className="list-inline-item">
                                <GoogleLogin
                                  clientId={google.CLIENT_ID}
                                  render={(renderProps) => (
                                    <Link
                                      to="#"
                                      className="social-list-item bg-danger text-white border-danger"
                                      onClick={renderProps.onClick}
                                    >
                                      <i className="mdi mdi-google" />
                                    </Link>
                                  )}
                                  onSuccess={googleResponse}
                                  onFailure={() => {}}
                                />
                              </li>
                            </ul>
                          </div> */}
                        </Col>
                      </Row>
                    </Form>
                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                {/* <p className="text-white-50">
                  Don't have an account ?{" "}
                  <Link to="/register" className="fw-medium text-primary">
                    {" "}
                    Register{" "}
                  </Link>{" "}
                </p> */}
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <Modal isOpen={!!otp} toggle={handleCloseOtpModal} centered>
        <ModalHeader toggle={handleCloseOtpModal}>
          {otp?.isNewSetup ? "Set Up Two-Factor Authentication" : "Enter Authentication Code"}
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={handleVerifyOtp}>
            {otp?.isNewSetup && (
              <div className="text-center mb-4">
                <p className="text-muted">
                  Scan this QR code with Google Authenticator (or a compatible app), then enter the 6-digit code below.
                </p>
                {otp?.qrCodeBase64 && (
                  <img
                    src={`data:image/png;base64,${otp.qrCodeBase64}`}
                    alt="2FA QR Code"
                    style={{ width: 200, height: 200 }}
                  />
                )}
                {otp?.manualEntryKey && (
                  <p className="mt-2">
                    <small className="text-muted">Or enter this key manually:</small>
                    <br />
                    <code>{otp.manualEntryKey}</code>
                  </p>
                )}
              </div>
            )}
            <div className="mb-3">
              <Label className="form-label">Authentication Code</Label>
              <div className="d-flex justify-content-center" style={{ gap: "10px" }} onPaste={handleOtpPaste}>
                {otpDigits.map((digit, index) => (
                  <Input
                    key={index}
                    innerRef={(el) => (otpInputRefs.current[index] = el)}
                    type="text"
                    inputMode="numeric"
                    autoComplete="one-time-code"
                    className="form-control text-center"
                    style={{
                      width: "45px",
                      height: "50px",
                      fontSize: "1.35rem",
                      fontWeight: 700,
                      color: "#0AB39C",
                      borderRadius: "8px",
                      border: "1px solid #ced4da",
                      boxShadow: digit
                        ? "0 3px 0 rgba(10, 179, 156, 0.35), inset 0 1px 2px rgba(0,0,0,0.06)"
                        : "0 3px 0 rgba(0, 0, 0, 0.12), inset 0 1px 2px rgba(0,0,0,0.06)",
                      transition: "box-shadow 0.15s ease",
                    }}
                    value={digit}
                    disabled={isLoading}
                    onChange={(e) => handleOtpDigitChange(index, e.target.value)}
                    onKeyDown={(e) => handleOtpKeyDown(index, e)}
                    onKeyUp={(e) => handleOtpKeyUp(index, e)}
                    maxLength={1}
                  />
                ))}
              </div>
              {isLoading && (
                <div className="d-flex align-items-center justify-content-center mt-3">
                  <Spinner size="sm" color="primary" className="me-2" />
                  <span className="text-muted">Verifying...</span>
                </div>
              )}
            </div>
            <div className="d-grid">
              <button
                className="btn btn-primary waves-effect waves-light"
                type="submit"
                disabled={isLoading || otpDigits.join("").length !== 6}
              >
                {isLoading ? <Spinner size="sm" /> : "Verify"}
              </button>
            </div>
          </Form>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

export default withRouter(Login);

Login.propTypes = {
  history: PropTypes.object,
};
